import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { Facebook, GitHub } from 'react-feather';
import { Link } from 'react-router-dom';

export default function Login() {
    return (
        <>
            <div className='login-image text-white'>
                <Container>
                    <Row>
                        <Col className='mx-auto text-center' lg={5}>
                            <h1>فرم ورود به پنل</h1>

                            <p>
                                با استفاده از این فرم زیبا میتوانید برای ورود به
                                سیستم یا ایجاد حساب کاربری جدید در پروژه خود
                                استفاده کنید.
                            </p>

                            <div className='space-100' />
                        </Col>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row className='justify-content-center'>
                    <Col xs={10} md={6} lg={4}>
                        <Card className='mt-10'>
                            <Card.Title className='bg-transparent p-3 text-center'>
                                <p className='mb-4'>ورود</p>

                                <Button variant='outline-dark' className='mr-2'>
                                    <GitHub size={17} />
                                </Button>

                                <Button
                                    variant='outline-primary'
                                    className='mr-2'
                                >
                                    <Facebook size={17} />
                                </Button>
                            </Card.Title>

                            <Card.Body>
                                <Form>
                                    <Form.Group
                                        className='mb-3'
                                        controlId='loginEmail'
                                    >
                                        <Form.Control
                                            type='email'
                                            placeholder='ایمیل یا نام کاربری'
                                            size='lg'
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        className='mb-3'
                                        controlId='loginPassword'
                                    >
                                        <Form.Control
                                            type='password'
                                            placeholder='رمز عبور'
                                            size='lg'
                                        />
                                    </Form.Group>

                                    <Form.Group
                                        className='mb-3'
                                        controlId='loginCheckbox'
                                    >
                                        <Form.Check
                                            type='checkbox'
                                            label='مرا به خاطر بسپار'
                                        />
                                    </Form.Group>

                                    <div className='d-grid gap-2'>
                                        <Button variant='secondary'>
                                            ورود به پنل
                                        </Button>
                                    </div>
                                </Form>
                                <br />
                                <span>آیا هنوز اکانت ندارید ؟</span>{' '}
                                <Link to='/auth/register'>یکی بسازید</Link>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
